import React from 'react';
import CustomTooltip from '../../../../../shared/components/common/tooltip/CustomTooltip';
import { getStatsIcon } from '../../../../../shared/utils/utils';
import { t } from 'i18next';
import { CustomSkeletonTile } from './components/skeleton-tile/CustomSkeletonTile';
import { TrendTag } from '../trend-tag/TrendTag';

interface TileBoxProps {
  hasData: boolean;
  value: number | string | null | undefined;
  trendValue: number | string;
  label: string;
  tooltipText: string;
  suffix?: string;
  // Optional secondary line rendered below the main value (e.g. the % under the
  // Visibility text interpretation on the V2 preview page).
  subValue?: string;
}

export const TileBox: React.FC<TileBoxProps> = ({
  hasData,
  value,
  trendValue,
  label,
  tooltipText,
  suffix = '',
  subValue,
}) => {
  if (!hasData) {
    return <CustomSkeletonTile />;
  }

  return (
    <div className="tile-box">
      <div className="tile-box__box">
        <label className="tile-box__name">
          {t(label)}
          <CustomTooltip tooltipText={tooltipText} />
        </label>
        <label className="tile-box__value">
          {`${value}${suffix}`}
          {trendValue !== 0 && <TrendTag trendValue={trendValue} suffix={suffix} />}
        </label>
        {subValue && <span className="tile-box__subvalue">{subValue}</span>}
      </div>
    </div>
  );
};
